<template>
  <div id="header">
    <div id="nav">
      <div class="nav-item">
        <!--
          <router-link to="/">&nbps;</router-link>
        -->
      </div>
      <div class="nav-item" />
      <div class="nav-item" />
      <div class="nav-item">
        <!--
          <router-link to="/about">&nbps;</router-link>
        -->
      </div>
    </div>
    <div v-if="FACE === 'MASTEK'" id="logo" class="center-element center-text">
      <img
        src="../assets/mastek_small@2x.png"
        srcset="
          ../assets/mastek_small@1x.png 1x,
          ../assets/mastek_small@2x.png 2x
        "
      />
    </div>
    <div v-else id="logo" class="center-element center-text">
      <img
        src="../assets/machinecore_logo_final@2x.png"
        srcset="
          ../assets/machinecore_logo_final@1x.png 1x,
          ../assets/machinecore_logo_final@2x.png 2x
        "
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      FACE: process.env.VUE_APP_FACE
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#header {
  padding-bottom: 60px;
}
#logo {
  width: 60%;
  margin: 0 auto;
}
@media (max-width: 600px) {
  #logo {
    width: 85%;
  }
  #logo img {
    max-width: 100%;
    height: auto;
  }
}
</style>
